module.exports = __webpack_public_path__ + "img/Digrab_Showreel_Thumbnail.8abc0c56.jpg";